import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { LocaleService } from '@next/core-lib/i18n';
import { Observable } from 'rxjs';

import { Environment } from 'src/environments/environment.model';

import { WeatherForecastDto } from '../shared/models/weather.models';

@Injectable({
  providedIn: 'root',
})
export class WeatherService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);
  private readonly localeService = inject(LocaleService);

  private readonly baseUrl = this.env.APIM_BASE_URL + '/meteo-service';

  getWeatherForecast(): Observable<WeatherForecastDto> {
    const locale = this.localeService.getLocale();
    const lang = locale.startsWith('nl') ? 'nl' : undefined;

    let params = new HttpParams();
    if (lang) {
      params = params.set('lang', lang);
    }

    return this.http.get<WeatherForecastDto>(`${this.baseUrl}/api/weather/forecast`, { params });
  }
}
